import { render, staticRenderFns } from "./CosmoClawMessageList.vue?vue&type=template&id=b6a29174&scoped=true"
import script from "./CosmoClawMessageList.vue?vue&type=script&lang=js"
export * from "./CosmoClawMessageList.vue?vue&type=script&lang=js"
import style0 from "./CosmoClawMessageList.vue?vue&type=style&index=0&id=b6a29174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a29174",
  null
  
)

export default component.exports